export default [
    {
        path: "/registration/registration",
        name: "supplier-registration",
        meta: { title: "supplier-registration", authRequired: false },
        component: () => import("../views/registration/registration.vue"),
    },
    {
        path: "/verify-supplier-certificate",
        name: "verify-supplier-certificate",
        meta: { title: "verify-supplier-certificate", authRequired: false },
        component: () => import("../views/auth/verify-supplier-certificate.vue"),
    }
]